import React, { createContext, useContext, useEffect, useRef } from "react";
import useWebSocket from "react-use-websocket";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const WS_ENDPOINT_URL= "wss://app.expresswebs.ca/ws/";
  const JWT_TOKEN = localStorage.getItem("token");
  const { sendMessage, lastMessage, readyState } = useWebSocket(WS_ENDPOINT_URL, {
    protocols: [JWT_TOKEN], // ✅ Send JWT for authentication
    shouldReconnect: () => true, // ✅ Auto-reconnect
  });

  // Send a ping every 2 minutes
  const pingInterval = useRef(null);
  useEffect(() => {
    if (readyState === 1) {
      console.log("✅ WebSocket Connected");
      pingInterval.current = setInterval(() => {
        sendMessage(JSON.stringify({ type: "ping" }));
        console.log("📡 Sending Ping");
      }, 120000);
    }
    return () => clearInterval(pingInterval.current);
  }, [readyState]);

  return (
    <WebSocketContext.Provider value={{ sendMessage, lastMessage, readyState }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
